import { useRef } from 'react'

import NextImage from 'next/image'
import { isNil } from 'ramda'

import { getStrapiMedia } from '../../utils'

type ImageType = {
  alternativeText?: string
  className?: string
  url?: string
  height?: number
  mime?: string
  width?: number
  id?: string | number
}

type VideoType = {
  controls?: boolean
  autoPlay?: boolean
  onPlay?: () => void
  muted?: boolean
}

export const StrapiMedia = ({
  alternativeText,
  className,
  url,
  height,
  mime,
  width,
  autoPlay = true,
  controls = false,
  muted = true,
  onPlay,
  id,
}: ImageType & VideoType) => {
  const src = getStrapiMedia(url)

  const videoRef = useRef<HTMLVideoElement>(null)

  // on mobile/touch devices only tap on default play icon starts playback
  const playPause = () => {
    const video = videoRef.current
    if (!video) {
      return
    }

    if (video.paused) {
      video.play()
    } else {
      video.pause()
    }
  }

  if (!isNil(mime) && mime.includes('video')) {
    return (
      <video
        ref={videoRef}
        disablePictureInPicture
        loop
        playsInline
        autoPlay={autoPlay}
        className={className}
        controls={controls}
        muted={muted}
        onClick={playPause}
        onPlay={onPlay}
        onPointerDown={playPause}
      >
        <source src={src} type={mime} />
      </video>
    )
  }

  return (
    <NextImage
      alt={alternativeText ?? ''}
      className={className}
      height={height ?? ('100%' as unknown as number)}
      id={id?.toString()}
      src={src}
      width={width ?? ('100%' as unknown as number)}
    />
  )
}
